import React from 'react';
import NotfoundPage from '../components/single_component/NotfoundPage';

export function NotFound() {
  return <NotfoundPage />;
}
